import React, { memo } from 'react';
import classNames from 'classnames/bind';
import { Text } from '@beef/ui-kit';
import styles from "./styles.module.pcss";
var cn = classNames.bind(styles);
export var Parameters = /*#__PURE__*/memo(function (_ref) {
  var parameters = _ref.parameters,
    cardType = _ref.cardType;
  return /*#__PURE__*/React.createElement(React.Fragment, null, parameters.map(function (parameter, idx) {
    return /*#__PURE__*/React.createElement("div", {
      className: cn('parameter', cardType && "parameter--".concat(cardType)),
      key: +idx,
      "data-t-id": "components-Parameters"
    }, /*#__PURE__*/React.createElement("div", {
      className: cn('parameter__strong')
    }, /*#__PURE__*/React.createElement(Text, {
      color: "grey95",
      size: "size4-m",
      tagType: "span"
    }, parameter.value)), /*#__PURE__*/React.createElement(Text, {
      color: "grey50",
      size: "size6-r",
      tagType: "span"
    }, parameter.unit));
  }));
});